/** One department role of a project, as GetAllProjectCostsForProject returns it. */
export interface ProjectCostRole {
  departmentId: number;
  departmentName: string;
  /** Empty when nobody holds the role on this project. */
  userMail: string | null;
  /** #4994: set instead of userMail when a whole department holds the role; such a role is not empty. */
  assignedDepartmentId?: number | null;
}

/**
 * A cost's responsible person is whoever holds the project role for the department of its
 * category. Returns that department's name when the role is empty, so the dialog can say which
 * role to fill; null when the cost can be saved. A category without a department (data from before
 * department was required) has no role to check, the same rule the backend applies.
 */
export function missingResponsibleDepartment(
  departmentId: number | null | undefined,
  roles: ProjectCostRole[] | null | undefined,
): string | null {
  if (departmentId == null) return null;
  const role = (roles ?? []).find((r) => r.departmentId === departmentId);
  if (role?.userMail?.trim() || role?.assignedDepartmentId != null) return null;
  // No role row at all: the backend lists every department, so this only happens when the roles
  // could not be loaded. Let the save through and leave the decision to the backend check.
  if (!role) return null;
  // Names are typed by admins and can carry stray spaces, which would end up before the full stop.
  return role.departmentName?.trim() || null;
}
